export default "__VITE_ASSET__DrKPqtrm__"